export const GET_LOGO_DETAILTAB = 'GET_LOGO_DETAILTAB'
export const GET_MOVIE_DETAIL = "GET_MOVIE_DETAIL";
export const GET_SCHEDULE_MOVIE_DETAIL = "GET_LICH_CHIEU_MOVIE_DETAIL";